import './assets/css/App.css'
import { Routes, Route, Navigate } from 'react-router-dom'
import AuthLayout from './layouts/auth'
import AdminLayout from './layouts/admin'
import GateKeeperLayout from './layouts/gatekeeper'
import { ChakraProvider } from '@chakra-ui/react'
import initialTheme from './theme/theme'
import { useState } from 'react'
import ProtectedRoute from 'components/ProtectedRoute/ProtectedRoute'

export default function Main () {
  // eslint-disable-next-line
  const [currentTheme, setCurrentTheme] = useState(initialTheme)

  return (
    <ChakraProvider theme={currentTheme}>
      <Routes>
        <Route path='auth/*' element={<AuthLayout />} />
        <Route element={<ProtectedRoute />}>
          <Route
            path='admin/*'
            element={
              <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
            }
          />
          <Route
            path='gatekeeper/*'
            element={<GateKeeperLayout />}
          />
        </Route>
        <Route path='/' element={<Navigate to='/auth/sign-in' replace />} />
        <Route path='*' element={<Navigate to='/auth/sign-in' replace />} />
      </Routes>
    </ChakraProvider>
  )
}
